import pararax3d from './3dPararax';

const para3d = new pararax3d();
/* ---------------------------------------

    -- マウス動作に合わせていい感じに値を返すやつ

--------------------------------------- */

export default class MouseManager{
    constructor(scroll){

        /* ポインターの位置情報 */
        this.pointer = {
            x : 0,
            y : 0
        }
        /* 慣性動作後の値 */
        this.obj = {
            x : 0,
            y : 0
        }

        /* 設定はここ */
        this.conf = {
            ease : 0.2,
        }

        this.para3d = para3d;

        this.scroll = scroll;

        this.moveElement = '.js__mouse-move.type-normal';
        this.moveElementRe = '.js__mouse-move.type-reverse';

    }
    set(type){ /* domにスタイル付けるなら("set",$target) | 値が欲しいだけなら()なし */

        this.obj.x += (this.pointer.x-this.obj.x)*this.conf.ease;
        this.obj.y += (this.pointer.y-this.obj.y)*this.conf.ease;
    }
    update(x,y){

        if(Useragnt.pc){
            this.pointer.x = x;
            this.pointer.y = y;
        }else{
            this.pointer.x = x;
            this.pointer.y = -y;
        }

    }

    move(mouse,para3d){

        if(!this.scroll.status.comp) return;

        let _x = para3d.moveMouse(mouse.x,mouse.y,'out')[2]*20/3;
        let _y = para3d.moveMouse(mouse.x,mouse.y,'out')[6]*20/3;
        let _z = para3d.moveMouse(mouse.x,mouse.y,'out')[8]*20/3;

        TweenMax.set(this.moveElement,{
            x:_x,
            y:-_y,
            z:-_z
        });
        TweenMax.set(this.moveElementRe,{
            x:-_x,
            y:_y,
            z:-_z
        });

    }

}